import React from "react";

export function CustomTabBar({ items, value, onChange }) {
  return (
    <div className="custom-tabbar">
      {items.map((item) => (
        <button
          key={item.id}
          className={
            "custom-tabbar-item " + (value === item.id ? "active" : "")
          }
          onClick={() => onChange(item.id)}
          type="button"
        >
          {item.icon && <i className={item.icon}></i>}
          <span className="custom-tabbar-label">{item.label}</span>
        </button>
      ))}
    </div>
  );
}
